import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { VerticalSpacingComponent } from './vertical-spacing.component';

@NgModule({
  imports: [CommonModule],
  exports: [VerticalSpacingComponent],
  declarations: [VerticalSpacingComponent],
  providers: []
})
export class VerticalSpacingModule {}
